import { render, staticRenderFns } from "./IrOrderMassReroute.vue?vue&type=template&id=47a060fc&"
import script from "./IrOrderMassReroute.vue?vue&type=script&lang=js&"
export * from "./IrOrderMassReroute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports